'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleRequestWidget = undefined;

var _PostMessageTypes = require('../../constants/PostMessageTypes');

var _createPostMessageAction = require('./createPostMessageAction');

var handleRequestWidget = exports.handleRequestWidget = (0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.REQUEST_WIDGET);


//////////////////
// WEBPACK FOOTER
// ./js/post-message/actions/handleRequestWidget.js
// module id = 1296
// module chunks = 3